module.exports = __webpack_public_path__ + "static/media/maca_cortada.d6c2761a.png";